import { dispatchWindowEvent } from '@packages/events/lib/dispatchEvent';
import { useEffect } from 'react';

export const DISPATCH_RESIZE_TYPE = '@hooks/useDispatchResize';

export enum DISPATCH_RESIZE {
    MOUNT,
    UNMOUNT,
}

const _resize = (data, _from: DISPATCH_RESIZE) => {
    setTimeout(() => {
        dispatchWindowEvent('resize', data);
    }, 50);
};

export const useDispatchResize = (data: { [key: string]: any } = {}) => {
    useEffect(() => {
        _resize(data, DISPATCH_RESIZE.MOUNT);
        return () => {
            _resize(data, DISPATCH_RESIZE.UNMOUNT);
        };
    }, ['']);
};
